var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-container"},[_c('div',{staticClass:"slider-track pointer",on:{"click":_vm.moveToClickPosition}},[_c('div',{ref:"sliderThumb",staticClass:"slider-thumb",style:({ left: _vm.thumbLeftPosition }),on:{"mousedown":_vm.startDragging}},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }